import React from 'react';
import './index.css';

export default (props) => (
    <div className="row sub-header d-flex align-items-center">
        <div className="img-sub-header-bg"></div>
        <div className="col-12 ml-4"><h3 className="text-secondary">{props.title}</h3></div>
    </div>
)